// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-checkbox .v-label {\n  color: var(--font-color) !important;\n}\n.form-checkbox .v-input--selection-controls__input {\n  margin-right: 0px !important;\n}\n.other-choice .other-text {\n  flex: 0 1 240px;\n  min-width: 140px;\n}", ""]);
// Exports
module.exports = exports;
